import React, { useContext, useEffect, useRef } from 'react';
import { useDragAndDropContext } from '../partials/DragAndDropContext';
import { appendClassName } from '../../../lib/bemUtils/classname';
import { SortableListContext } from '../SortableListContext';

export function CustomDragLayer() {
  const { draggedItem, subscribeForNewMousePosition } = useDragAndDropContext();

  const dragLayerRef = useRef<HTMLDivElement>(null);
  const context = useContext(SortableListContext);

  useEffect(() => {
    return subscribeForNewMousePosition((coords, width) => {
      const transform = `translate(${coords.x - (width / 2 - 10)}px, ${coords.y - 15}px)`;

      if (dragLayerRef.current) {
        dragLayerRef.current.style.transform = transform;
        dragLayerRef.current.style.webkitTransform = transform;
        dragLayerRef.current.style.width = `${width.toString()}px`;
      }
    });
  }, [subscribeForNewMousePosition]);

  const isHidden = draggedItem ? undefined : true;
  return (
    <div className={appendClassName(isHidden && 'hidden', 'custom-drag-layer')}>
      <div
        ref={dragLayerRef}
        className={appendClassName(
          'custom-drag-layer__container',
          context?.hasDarkDragLayerBackground ? 'custom-drag-layer__container--dark-background' : '',
        )}
      >
        {draggedItem && <draggedItem.Preview {...draggedItem.props} />}
      </div>
    </div>
  );
}
